import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body, Typography } from "../styled";
import { format } from "date-fns";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const WorkActivity: FC = () => {
    return (
        <Box mt={1}>
            <Header>
                <Box display={'flex'}>
                    <Typography mb={1} ml={15}>Наименование организации, учебного заведения</Typography>
                    <Typography mb={1} ml={18}>Дата поступления</Typography>
                    <Typography mb={1} ml={9}>Дата ухода</Typography>
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
            </Header>
            <Body>
                <Box display="flex" alignItems="center">
                    <Typography mr={8.5}>Дата поступления</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px" }} 
                    />
                    <Typography mr={2} ml={1}>Дата ухода</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px" }} 
                    />
                </Box>
                <Box display="flex" alignItems="center">
                    <Typography mr={2} mt={2}>Наименование организации, образовательного учреждения, место его нахождения</Typography>
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "700px"}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={3.7}>Профессия, должность</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "700px"}}
                    />
                </Box>
            </Body>
        </Box>
    );
};

export default WorkActivity;

